export const lowercaseKeys = (obj) => Object.fromEntries(Object.entries(obj ?? {}).map(([k, v]) => [k.toLowerCase(), v]));

export const normalizeAgency = (agency, index) => {
  const n = lowercaseKeys(agency);
  const agencyKey = n.agencykey ?? n.agency_key;
  const agentKey = n.agentkey ?? n.agent_key;
  return {
    id: agencyKey ?? agentKey ?? `agency-${index}`,
    agencyKey,
    agentKey,
    agencyName: n.agencyname ?? n.agency_name,
    taxId: n.taxid ?? n.tax_id,
    address: n.address,
    email: n.email,
    fileCount: n.filecount ?? n.file_count,
  };
};

export const normalizeProducer = (producer, index) => {
  const n = lowercaseKeys(producer);
  const producerKey = n.producerkey ?? n.producer_key;
  const policyNumber = n.policynumber ?? n.policy_number;
  const reinsuranceYear = n.reinsuranceyear ?? n.reinsurance_year;
  const baseId = producerKey ?? policyNumber ?? `producer-${index}`;
  return {
    id: reinsuranceYear != null && reinsuranceYear !== "" ? `${baseId}-${reinsuranceYear}` : baseId,
    producerKey,
    policyNumber,
    name: n.name,
    reinsuranceYear,
  };
};

export const matchesReinsuranceYear = (record, year) => {
  if (year == null || year === "") return true;
  const recordYear = record?.reinsuranceYear;
  if (recordYear == null || recordYear === "") return false;
  return Number(recordYear) === Number(year);
};

export const normalizeSummary = (result) => {
  const root = lowercaseKeys(result);
  const aip = lowercaseKeys(root.aip ?? root);
  const agencySource = aip.agencies ?? aip["aip.agencies"] ?? root.agencies ?? [];
  const producerSource = aip.producers ?? aip["aip.producers"] ?? root.producers ?? [];
  const agencies = (Array.isArray(agencySource) ? agencySource : []).map((agency, index) =>
    normalizeAgency(agency, index)
  );
  const producers = (Array.isArray(producerSource) ? producerSource : []).map((producer, index) =>
    normalizeProducer(producer, index)
  );

  const seenAgencies = new Set();
  const seenProducers = new Set();

  return {
    server: aip.server ?? root.server,
    generatedAt: aip.generatedat ?? aip.generated_at ?? root.generatedat ?? root.generated_at,
    agencies: agencies.filter((a) => {
      const key = a.id;
      if (seenAgencies.has(key)) return false;
      seenAgencies.add(key);
      return true;
    }),
    producers: producers.filter((p) => {
      const key = p.id;
      if (seenProducers.has(key)) return false;
      seenProducers.add(key);
      return true;
    }),
  };
};

export const getPresignedUrl = (result) => result?.presignedUrl ?? result?.presignedurl;

export const normalizeFile = (file, index = 0) => {
  const n = lowercaseKeys(file);
  const key = n.key ?? "";
  return {
    id: key || `file-${index}`,
    key,
    size: n.size ?? 0,
    lastModified: n.lastmodified ?? n.last_modified ?? null,
  };
};

export const normalizeFiles = (files) => (files ?? []).map(normalizeFile);

export const isValidSummaryPayload = (result) => {
  if (!result || typeof result !== "object" || Array.isArray(result)) return false;
  const aip = result.aip ?? result;
  if (!aip || typeof aip !== "object" || Array.isArray(aip)) return false;

  const agencies = aip.agencies;
  const producers = aip.producers;
  const agenciesOk = agencies == null || (Array.isArray(agencies) && agencies.every((a) => a && typeof a === "object" && !Array.isArray(a)));
  const producersOk =
    producers == null || (Array.isArray(producers) && producers.every((p) => p && typeof p === "object" && !Array.isArray(p)));

  return agenciesOk && producersOk;
};
